module.exports = __webpack_public_path__ + "img/4.d911bd2b.gif";